<div class="row m-b-xs" (dblclick)="editModeOn()">
    <div *ngIf="title" class="dv-label col-sm-3 strong" data-toggle="tooltip" data-placement="top" [title]="tooltipText">
        {{ title }}
    </div>

    <div *ngIf="!editOnly" class="dv-value col-sm-12"
         [ngClass]="{'hidden': isEditMode, 'col-sm-9': title, 'col-sm-12': !title}">
        <ng-container *ngFor="let item of listRoles()">
            <span *ngIf="value == item.code" [class]="'label ' + item.class">{{ item.name }}</span>
        </ng-container>

        <i *ngIf="!noEdit" (click)="editModeOn()"
           class="fa fa-pencil pull-right" data-toggle="tooltip" data-placement="top" title="Edit"></i>

    </div>

    <div *ngIf="!noEdit"
         class="dv-value-edit col-sm-12"
         [ngClass]="{'hidden': !isEditMode, 'col-sm-9': title, 'col-sm-12': !title}">
        <select (keyup.enter)="apply()" class="form-control" [(ngModel)]="value">
            <option *ngFor="let type of directoryService.residentOccupancyTypes" [value]="type.code">
                {{type.name}}
            </option>
        </select>

        <button *ngIf="!editOnly" (click)="apply()" type="button">
            <i class="fa fa-check"></i>
        </button>

        <button *ngIf="!editOnly" (click)="cancel()" type="button">
            <i class="fa fa-times"></i>
        </button>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/fields/role-field/role-field.template.html